import { MediaUpload } from "@aqar-app/react-ui";
import React, { useEffect, useRef, useState } from "react";
import { dispatchCtxChange, dispatchCtxUiEvent } from "@/components/add-v2/ui";
import { uploadImg } from "@/components/media-upload/mediaUpload";
import { useAuthState } from "@/contexts/auth/auth.provider";
import Config from "@/common/config";
import { getDynamicLabel } from "@/components/add-v2/validate";

import css from "./.module.scss";
export function PhotoPickerComponent({
  rules,
  label,
  dynamic,
  value,
  name,
  ctxRef,
  mime,
  nested,
  ...props
}) {
  const { token } = useAuthState();
  const rootRef = useRef(null);
  const [src, setSrc] = useState(null);
  useEffect(() => {
    setSrc(
      value?.map((filename) =>
        filename.startsWith("http")
          ? filename
          : Config.IMAGES_BASE_URL + "webp/1080x0/props/" + filename,
      ),
    );
  }, []);

  return (
    <div ref={rootRef} className={css.picker}>
      <MediaUpload
        src={src}
        placeholder={
          label?.dynamic ? getDynamicLabel({ label, ctx }) : label?.ar
        }
        onStart={() => {
          dispatchCtxUiEvent(rootRef.current, {
            type: "loading",
            value: true,
          });
        }}
        asyncUpload={async (file) => {
          let ext = file.name.split(".").pop();
          if (ext === "jpeg") {
            ext = "jpg";
          }
          if (mime === "image/*") {
            return await uploadImg(file, token, "props", "image", ext);
          }

          if (mime === "video/*")
            return await uploadImg(file, token, "videos", "video", ext);
        }}
        onChange={(files) => {
          dispatchCtxUiEvent(rootRef.current, {
            type: "loading",
            value: false,
          });

          dispatchCtxChange(document.body, {
            value: files,
            name,
            nested,
          });
        }}
        mime={mime}
        {...props}
      />
    </div>
  );
}
